const collator = new Intl.Collator("fr", { sensitivity: "base", numeric: true });

type StudentName = { lastname?: string | null; firstname?: string | null };

export const studentName = (student?: StudentName) =>
  [student?.lastname, student?.firstname].filter(Boolean).join(" ");

export const compareStudentNames = (a?: StudentName, b?: StudentName) =>
  collator.compare(a?.lastname?.trim() || "", b?.lastname?.trim() || "") ||
  collator.compare(a?.firstname?.trim() || "", b?.firstname?.trim() || "");
